import Radium from "radium";
import React from "react";

import { IAuthorization } from "@common/models";
import { random } from "@common";
import styles from "./authorization.styles";

export interface IUserRolesListProps {
  authorizations: IAuthorization[];
}
const listItemStyle = { ...styles.listItem, fontSize: "13px", flex: "2" };

const rolesList = ({ authorizations }) => (
  <div style={listItemStyle as any}>
    <div style={styles.subItem as any}>
      {authorizations
        ? authorizations.map(auth => {
            const uniqueKey = random();
            return (
              <div style={{ marginBottom: "5px" }} key={uniqueKey}>
                {auth.claim}
              </div>
            );
          })
        : null}
    </div>
  </div>
);

export default Radium(rolesList);
